import {
  COMUNICATION_SIDEBAR_SHOW_OFF,
  ALERT_SET,
  ALERT_DELETE,
  ALERT_SET_LOADING_STATUS,
  ALERT_CLEAR,
  ALERT_SET_COUNT,
  ALERT_SET_FOR_LABORATORY,
  ALERT_START_LOADING_FOR_LABORATORY,
  ALERT_SET_FOR_LABORATORY_LOADING_STATUS,
  ALERT_SET_AS_READ,
  ALERT_CLEAR_FOR_LABORATORY,
  ALERT_SET_LABORATORY_CONTEXT,
  ALERT_REMEMBER_LABORATORY_IDS,
  ALERT_SET_LABORATORY_READ_PENDING,
  ALERT_MARK_LABORATORY_AS_READ,
  TAB_SHOW_OFF,
  MESSAGE_DELETE,
  MESSAGE_SET_FOR_LABORATORY,
  MESSAGE_CLEAR,
  MESSAGE_SET_AS_READ,
  MESSAGE_SET_COUNT,
} from '../types'
import comunicationService from '@/api/comunication'
import { getCookie } from '../../utils/auth-utils'
import Moment from 'moment'

const laboratoryReadRequests = new WeakMap()
const normalizeId = value => value === null || value === undefined ? null : String(value).trim() || null
const notificationId = notification => normalizeId(notification && notification['id-notification'])
const sortReadNotifications = notifications => [...notifications].sort(
  (a, b) => new Date(b['read-date']) - new Date(a['read-date'])
)

const state = {
  comunicationSidebarShowOff: false,
  notifications: [],
  alertLoadingStatus: 'STATUS_INITIAL',
  alertsCount: 0,
  notificationsForLaboratories: [],
  alertsForLaboratoryLoadingStatus: 'STATUS_INITIAL',
  alertsForLaboratoryRequestId: 0,
  alertsForLaboratoryId: null,
  alertsForLaboratorySessionId: 0,
  seenLaboratoryAlertIds: [],
  laboratoryAlertReadPendingIds: [],
  tabShowOff: false,
  messageForLaboratories: [],
  messageCount: 0,
  readedNotifications: [],
  notificationOffset: 0,
  notificationLimit: 20,
}

const mutations = {
  // Sidebar
  [COMUNICATION_SIDEBAR_SHOW_OFF](state, value) {
    state.comunicationSidebarShowOff = value
  },
  // Tabs
  [TAB_SHOW_OFF](state, value) {
    state.tabShowOff = value
  },
  // Notificações
  [ALERT_SET](state, notifications) {
    state.notifications = [...state.notifications, ...notifications]
    state.notificationOffset = state.notificationOffset + notifications.length
  },
  [ALERT_DELETE](state, index) {
    state.notifications.splice(index, 1)
    state.alertsCount--
  },
  [ALERT_SET_LOADING_STATUS](state, alertLoadingStatus) {
    state.alertLoadingStatus = alertLoadingStatus
  },
  [ALERT_CLEAR](state) {
    state.notifications = []
    state.notificationOffset = 0
  },
  [ALERT_SET_COUNT](state, value) {
    state.alertsCount = value
  },
  [ALERT_SET_FOR_LABORATORY](state, notificationsForLaboratories) {
    state.notificationsForLaboratories = notificationsForLaboratories
  },
  [ALERT_START_LOADING_FOR_LABORATORY](state) {
    state.alertsForLaboratoryRequestId++
    state.alertsForLaboratoryLoadingStatus = 'STATUS_LOADING'
  },
  [ALERT_SET_FOR_LABORATORY_LOADING_STATUS](state, status) {
    state.alertsForLaboratoryLoadingStatus = status
  },
  [ALERT_SET_AS_READ](state, notification) {
    state.notifications = notification
  },
  [ALERT_CLEAR_FOR_LABORATORY](state) {
    state.notificationsForLaboratories = []
    state.readedNotifications = []
    state.alertsCount = 0
    state.alertsForLaboratoryLoadingStatus = 'STATUS_INITIAL'
    state.alertsForLaboratoryRequestId++
    state.alertsForLaboratoryId = null
    state.alertsForLaboratorySessionId++
    state.seenLaboratoryAlertIds = []
    state.laboratoryAlertReadPendingIds = []
    state.comunicationSidebarShowOff = false
  },
  [ALERT_SET_LABORATORY_CONTEXT](state, laboratoryId) {
    state.alertsForLaboratoryId = laboratoryId
  },
  [ALERT_REMEMBER_LABORATORY_IDS](state, notifications) {
    state.seenLaboratoryAlertIds = [...new Set([
      ...state.seenLaboratoryAlertIds,
      ...notifications.map(notificationId).filter(id => id !== null),
    ])]
  },
  [ALERT_SET_LABORATORY_READ_PENDING](state, { id, pending }) {
    state.laboratoryAlertReadPendingIds = state.laboratoryAlertReadPendingIds.filter(pendingId => pendingId !== id)
    if (pending) state.laboratoryAlertReadPendingIds.push(id)
  },
  [ALERT_MARK_LABORATORY_AS_READ](state, notification) {
    const id = notificationId(notification)
    state.notificationsForLaboratories = state.notificationsForLaboratories.filter(item => notificationId(item) !== id)
    state.readedNotifications = sortReadNotifications([
      notification,
      ...state.readedNotifications.filter(item => notificationId(item) !== id),
    ])
    state.alertsCount = state.notificationsForLaboratories.length
    state.seenLaboratoryAlertIds = [...new Set([...state.seenLaboratoryAlertIds, id])]
    // Uma consulta iniciada antes da confirmação pode trazer o aviso ainda não lido.
    state.alertsForLaboratoryRequestId++
    if (state.alertsForLaboratoryLoadingStatus === 'STATUS_LOADING') {
      state.alertsForLaboratoryLoadingStatus = 'STATUS_SUCCESS'
    }
  },
  // Mensagens
  [MESSAGE_DELETE](state, index) {
    state.messageForLaboratories.splice(index, 1)
    state.messageCount--
  },
  [MESSAGE_SET_FOR_LABORATORY](state, messageForLaboratories) {
    state.messageForLaboratories = messageForLaboratories
  },
  [MESSAGE_CLEAR](state) {
    state.messageForLaboratories = []
  },
  [MESSAGE_SET_AS_READ](state, message) {
    state.messageForLaboratories = message
  },
  [MESSAGE_SET_COUNT](state, value) {
    state.messageCount = value
  },
  setReadedNotifications(state, readedNotifications) {
    state.readedNotifications = readedNotifications
  },
}

const getters = {
  // Sidebar
  isComunicationSidebarVisible: state => {
    return state.comunicationSidebarShowOff
  },
  // Tab
  whereIsTabSelected: state => {
    return state.tabShowOff
  },
  // Notificações
  notifications: state => {
    return state.notifications
  },
  alertLoadingStatus: state => {
    return state.alertLoadingStatus
  },
  getAlertsNumber: state => {
    return state.alertsCount
  },
  notificationsForLaboratories: state => {
    return state.notificationsForLaboratories
  },
  alertsForLaboratoryLoadingStatus: state => {
    return state.alertsForLaboratoryLoadingStatus
  },
  isLaboratoryAlertReadPending: state => notification => {
    return state.laboratoryAlertReadPendingIds.includes(notificationId(notification))
  },
  readedNotifications: state => {
    return state.readedNotifications
  },
  // Mensagens
  getMessagesNumber: state => {
    return state.messageCount
  },
  messageForLaboratories: state => {
    return state.messageForLaboratories
  },
}

const actions = {
  setComunicationSidebarShowOff: function ({ commit }, value) {
    commit(COMUNICATION_SIDEBAR_SHOW_OFF, value)
  },
  changeTabShowOff: function ({ commit }, value) {
    commit(TAB_SHOW_OFF, value)
  },
  getServiceAlert: function ({ commit, dispatch, state }) {
    commit(ALERT_SET_LOADING_STATUS, 'STATUS_LOADING')
    return comunicationService
      .getAllAlerts(state.notificationLimit, state.notificationOffset)
      .then(response => {
        let notifications = response.data
        if (notifications && notifications.length > 0) {
          commit(ALERT_SET, notifications)
          if (notifications.length < state.notificationLimit) {
            commit(ALERT_SET_LOADING_STATUS, 'STATUS_END')
          } else {
            commit(ALERT_SET_LOADING_STATUS, 'STATUS_LOADED')
          }
        } else {
          commit(ALERT_SET_LOADING_STATUS, 'STATUS_END')
        }
      })
      .catch(() => {
        commit(ALERT_SET_LOADING_STATUS, 'STATUS_FAILED')
      })
  },
  setInitialLoadingStatus: function ({ commit }) {
    commit(ALERT_SET_LOADING_STATUS, 'STATUS_INITIAL')
  },
  clearAllAlertData: function ({ commit }) {
    commit(ALERT_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(ALERT_CLEAR)
  },
  resetNotificationPagination: function ({ commit }) {
    commit(ALERT_CLEAR)
    commit(ALERT_SET_LOADING_STATUS, 'STATUS_INITIAL')
  },
  clearAlertDataForLaboratory: function ({ commit, state }) {
    laboratoryReadRequests.delete(state)
    commit(ALERT_CLEAR_FOR_LABORATORY)
  },
  async getAlertsForLaboratory({ commit, dispatch, state, rootGetters }) {
    const profile = getCookie('profile')
    const laboratoryId = normalizeId(profile && profile.id_laboratory)
    if (laboratoryId === null) {
      dispatch('clearAlertDataForLaboratory')
      return
    }
    if (state.alertsForLaboratoryId !== null && state.alertsForLaboratoryId !== laboratoryId) {
      dispatch('clearAlertDataForLaboratory')
    }
    commit(ALERT_SET_LABORATORY_CONTEXT, laboratoryId)

    commit(ALERT_START_LOADING_FOR_LABORATORY)
    const requestId = state.alertsForLaboratoryRequestId
    const startDate = Moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'
    const endDate = Moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59'

    try {
      const response = await comunicationService.getAlertsForLaboratory({
        idLaboratory: profile.id_laboratory,
        startDate: startDate,
        endDate: endDate,
        enabled: 1,
      })
      if (requestId !== state.alertsForLaboratoryRequestId) return
      const currentProfile = getCookie('profile')
      if (normalizeId(currentProfile && currentProfile.id_laboratory) !== laboratoryId) {
        dispatch('clearAlertDataForLaboratory')
        return
      }

      const notificationsForLaboratories = response.data.notification
      const readedNotifications = sortReadNotifications(response.data.notificationHistory)
      const size = notificationsForLaboratories.length
      const hasNewUnread = notificationsForLaboratories.some(notification => {
        const id = notificationId(notification)
        return id !== null && !state.seenLaboratoryAlertIds.includes(id)
      })

      commit(ALERT_SET_FOR_LABORATORY, notificationsForLaboratories)
      commit('setReadedNotifications', readedNotifications)
      commit(ALERT_SET_COUNT, size)
      commit(ALERT_SET_FOR_LABORATORY_LOADING_STATUS, 'STATUS_SUCCESS')
      commit(ALERT_REMEMBER_LABORATORY_IDS, [...notificationsForLaboratories, ...readedNotifications])
      if (hasNewUnread && rootGetters.toggle && rootGetters.toggle.notification_view) {
        commit(COMUNICATION_SIDEBAR_SHOW_OFF, true)
      }
    } catch (error) {
      if (requestId === state.alertsForLaboratoryRequestId) {
        commit(ALERT_SET_FOR_LABORATORY_LOADING_STATUS, 'STATUS_FAILED')
      }
    }
  },
  markLaboratoryAlertAsRead({ commit, state }, notification) {
    const id = notificationId(notification)
    const profile = getCookie('profile')
    const laboratoryId = normalizeId(profile && profile.id_laboratory)
    if (id === null || laboratoryId === null || state.alertsForLaboratoryId !== laboratoryId) {
      return Promise.resolve(false)
    }

    const sessionId = state.alertsForLaboratorySessionId
    let requests = laboratoryReadRequests.get(state)
    if (!requests) {
      requests = new Map()
      laboratoryReadRequests.set(state, requests)
    }
    const pendingRequest = requests.get(id)
    if (pendingRequest && pendingRequest.sessionId === sessionId && pendingRequest.laboratoryId === laboratoryId) {
      return pendingRequest.promise
    }

    const unread = state.notificationsForLaboratories.find(item => notificationId(item) === id)
    if (!unread) {
      return Promise.resolve(state.readedNotifications.some(item => notificationId(item) === id))
    }

    const payload = {
      ...unread,
      read: true,
      'id-laboratory': profile.id_laboratory,
      'read-date': Moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    }
    const request = { sessionId, laboratoryId, promise: null }
    requests.set(id, request)
    commit(ALERT_SET_LABORATORY_READ_PENDING, { id, pending: true })
    request.promise = (async () => {
      try {
        await comunicationService.markAlertAsRead(payload)
        const currentProfile = getCookie('profile')
        if (
          sessionId !== state.alertsForLaboratorySessionId ||
          laboratoryId !== state.alertsForLaboratoryId ||
          normalizeId(currentProfile && currentProfile.id_laboratory) !== laboratoryId
        ) return false

        commit(ALERT_MARK_LABORATORY_AS_READ, payload)
        return true
      } catch (error) {
        return false
      } finally {
        if (sessionId === state.alertsForLaboratorySessionId) {
          commit(ALERT_SET_LABORATORY_READ_PENDING, { id, pending: false })
        }
        if (requests.get(id) === request) requests.delete(id)
      }
    })()
    return request.promise
  },
  clearAllMessageData: function ({ commit }) {
    commit(MESSAGE_CLEAR)
  },
  deleteSelectedMessages({ commit }, index) {
    commit(MESSAGE_DELETE, index)
  },
  deleteSelectedAlerts({ commit }, index) {
    commit(ALERT_DELETE, index)
  },
  getMessagesForLaboratory({ commit }) {
    let profile = getCookie('profile')
    let startDate = Moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
    let endDate = Moment(new Date()).format('YYYY-MM-DD hh:mm:ss')

    return comunicationService
      .getMessagesForLaboratory({
        idLaboratory: profile.id_laboratory,
        startDate: startDate,
        endDate: endDate,
        enabled: 1,
      })
      .then(response => {
        let size = response.data.length
        let messagesForLaboratories = response.data
        commit(MESSAGE_SET_FOR_LABORATORY, messagesForLaboratories)
        commit(MESSAGE_SET_COUNT, size)
      })
      .catch(response => {
        console.log(response)
      })
  },
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
